<div
  data-cy="error-dialog"
  [class.error-dialog--centralized]="theme === 'centralized'"
  class="error-dialog">
  <div class="header">
    <h3 class="title">{{ title }}</h3>
    <button
      class="mz-button only-icon small ghost close white"
      (click)="handleEvent('CLOSE'); $event.stopPropagation()">
      <mzic-svg src="assets/icons/mzic-close.svg" />
    </button>
  </div>

  @if (iconUrl) {
    <div class="error-dialog__icon">
      <mzic-svg [src]="iconUrl" [class]="iconClass + ' ' + iconSize" />
    </div>
  }
  <div class="error-dialog__content">
    <p>
      {{ description }}
    </p>
    @if (extra) {
      <p>{{ extra }}</p>
    }
  </div>
  <footer class="footer">
    <button
      data-cy="error-dialog-close-button"
      (click)="handleEvent('CLOSE')"
      class="mz-button secondary small">
      {{ cancelButton }}
    </button>
    <button
      data-cy="error-dialog-try-again-button"
      (click)="handleEvent('TRY_AGAIN')"
      class="mz-button danger small">
      {{ confirmButton }}
    </button>
  </footer>
</div>
